// @flow
export const HEADER_THEME_API = {
  header: '',
  h1: '',
  h2: '',
  h3: '',
  h4: '',
  thin: '',
  light: '',
  regular: '',
  medium: '',
  bold: ''
};
